import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Cache } from 'aws-amplify';
import { SettingsHttpService } from '../../../../../core/settings';
import { MachineRouteService } from '../../machine-route.service';

@Component({
  selector: 'kt-shadow-settings',
  templateUrl: './shadow-settings.component.html',
  styleUrls: ['./shadow-settings.component.scss']
})

export class ShadowSettingsComponent implements OnInit {

  selectedMachine: any;

	shadowData;
	reported;


	editSettingsForm: FormGroup;
	user;
	role;

	constructor(private _snackBar: MatSnackBar, private http: SettingsHttpService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private machineRouteService: MachineRouteService) { }

	ngOnInit() {
		this.selectedMachine = this.machineRouteService.getMachine(this.route);
		if (!this.selectedMachine) return;
		this.user = Cache.getItem('userAttr');
		this.role = this.user['custom:role'];

		this.getShadowDetails();

		this.getMacSettings();

		this.editSettingsForm = new FormGroup({
			'brew_chk_num' : new FormControl(null),
			'brew_chk_hi' : new FormControl(null),
			'brew_chk_lo': new FormControl(null),
			'cof_cab_factor': new FormControl(null)
		});
	}

	onRefresh(){
		this.getShadowDetails();
		this.getMacSettings();
	}

	getShadowDetails(){
		this.http.getShadowData(this.selectedMachine.serial_no)
		.subscribe(shData => {
			if(shData.payload){
				try {
					console.log(JSON.parse(shData.payload));
					this.shadowData = JSON.parse(shData.payload).state;
					this.reported = this.shadowData.reported;
					setTimeout(() => {
						this.cdr.detectChanges();
					}, 100);
				} catch (error) {
					console.log(error);
				}
			}else{
				console.log('No Shadow yet');
			}
		});
	}

	getMacSettings(){
		this.http.getMachineSettings(this.selectedMachine.machine_id)
		.subscribe(settings => {
			if(settings){
				this.editSettingsForm.patchValue({
					'brew_chk_num' : settings.brew_chk_num || null,
					'brew_chk_hi' : settings.brew_chk_hi || null,
					'brew_chk_lo': settings.brew_chk_lo || null,
					'cof_cab_factor': settings.cof_cab_factor || null
				});
			}
		});
	}

	hasApplied(key){
		if(this.reported){
			if(this.reported[key] == this.editSettingsForm.get(key).value){

				return true;
			}else{
				return false;
			}
		}else{
			return false;
		}
	}

	onSubmited(){
		let formVal = this.editSettingsForm.value;
		if(formVal.brew_chk_num != null || formVal.brew_chk_hi != null ||
			formVal.brew_chk_lo != null || formVal.cof_cab_factor != null){
				formVal.machine_id = this.selectedMachine.machine_id;
				formVal.serial_no = this.selectedMachine.serial_no;
			this.http.updateMachineSettings(formVal)
			.subscribe(result => {
				this.showSnackBar("Settings Updated!!!",5000);
			},error => {
				console.log(error);
				this.showSnackBar("Unable to update!!!",5000);
			});
		}else{
			this.showSnackBar("Nothing to update.", 0);
		}
	}

	onBack(){

	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

}
